/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_LengthInputs */



/**
* | output |
* | --- |
* | "Password must be at least 6 characters long" |
*
* @param {Login_Error_Password_LengthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_length = /** @type {((inputs?: Login_Error_Password_LengthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_LengthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le mot de passe doit contenir au moins 6 caractères")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Passwort muss mindestens 6 Zeichen lang sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La password deve essere lunga almeno 6 caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пароль должен состоять не менее чем из 6 символов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La contraseña debe tener al menos 6 caracteres.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码长度必须至少为 6 个字符。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードは6文字以上でなければなりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड कम से कम 6 अक्षरों का होना चाहिए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A senha deve ter pelo menos 6 caracteres.")
	return /** @type {LocalizedString} */ ("Password must be at least 6 characters long")
});